var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { persistentKVStore } from '../../persistence';
import { Http } from '../transport';
import { buildErrorMessage } from './utils';
var Endpoint = /** @class */ (function () {
    function Endpoint(baseUrl) {
        this.authenticated = false;
        this.displayErrors = false;
        this.getErrorMessage = function (error) {
            return buildErrorMessage(error);
        };
        this.http = new Http({ baseUrl: baseUrl });
    }
    Endpoint.prototype.getAuthHeaders = function () {
        var token = persistentKVStore.getItem('token');
        if (!token) {
            return {};
        }
        return {
            Authorization: "JWT ".concat(token),
        };
    };
    Endpoint.prototype.buildHeaders = function (headers) {
        var preparedHeaders = headers ? __assign({}, headers) : {};
        if (this.authenticated) {
            var authHeaders = this.getAuthHeaders();
            preparedHeaders = __assign(__assign({}, authHeaders), preparedHeaders);
        }
        return preparedHeaders;
    };
    Endpoint.prototype.buildSharedOptions = function (options) {
        var headers = this.buildHeaders(options === null || options === void 0 ? void 0 : options.headers);
        var meta = {
            displayErrors: this.displayErrors,
            getErrorMessage: this.getErrorMessage,
        };
        return __assign(__assign({}, (options || {})), { headers: headers, meta: meta });
    };
    return Endpoint;
}());
export { Endpoint };
